import {
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import {
  FaBarcode,
  FaHashtag,
  FaMapMarkerAlt,
  FaUniversity,
  FaUser,
} from "react-icons/fa";
import { MdRemoveRedEye } from "react-icons/md";

import config from "../../../../../config.json";

const apiUrl = config.apiUrl;
export default function BankDetailsModal({
  handleShowBankDetails,
  handleClose,
  show,
  isLoading,
  bankDetails,
}) {
  const details = bankDetails
    ? [
        {
          icon: <FaUser />,
          label: "Account Holder",
          value: bankDetails.accountHolderName || "N/A",
        },
        {
          icon: <FaUniversity />,
          label: "Bank Name",
          value: bankDetails.bankName || "N/A",
        },
        {
          icon: <FaMapMarkerAlt />,
          label: "Branch",
          value: bankDetails.branchName || "N/A",
        },
        {
          icon: <FaHashtag />,
          label: "Account Number",
          value: bankDetails.accountNumber || "N/A",
        },
        {
          icon: <FaBarcode />,
          label: "IFSC Code",
          value: bankDetails.ifscCode || "N/A",
        },
      ]
    : [];

  return (
    <div>
      {isLoading ? (
        <Button
          variant="primary"
          className="btn btn-primary float-end "
          disabled
        >
          <Spinner size="sm" animation="border" className="me-1" />
          Please wait...
        </Button>
      ) : (
        <Button
          variant="primary"
          onClick={handleShowBankDetails}
          className="btn btn-primary float-end"
        >
          <MdRemoveRedEye size={20} className="me-1" />
          Bank Details
        </Button>
      )}{" "}
      <Modal
        show={show}
        onHide={handleClose}
        animation={true}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bank Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="py-2">
            {details.length > 0 ? (
              <Row>
                {/* Left Side - Bank Details */}
                <Col md={6} className="d-flex flex-column gap-3">
                  {details.map((detail, index) => (
                    <Card key={index} className="shadow-sm p-1 border-0">
                      <Row className="align-items-center">
                        <Col xs="auto">
                          <div
                            className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                            style={{ width: 50, height: 50 }}
                          >
                            <span className="fs-5">{detail.icon}</span>
                          </div>
                        </Col>
                        <Col>
                          <div
                            className="text-danger"
                            style={{
                              fontSize: 18,
                            }}
                          >
                            {detail.label}
                          </div>
                          <h6 className="text-primary fw-bold">
                            {detail.value}
                          </h6>
                        </Col>
                      </Row>
                    </Card>
                  ))}
                </Col>

                {/* Right Side - QR Code */}
                <Col
                  md={6}
                  className="d-flex flex-column align-items-center justify-center"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {bankDetails?.qrImageName ? (
                    <>
                      <img
                        src={`${apiUrl}/settings/bank-detail-QR-image/${bankDetails?.qrImageName}`}
                        alt="Bank QR Code"
                        width={"65%"}
                        // height={80}
                        className="img-fluid"
                      />
                      <small className="text-muted mt-2 text-center">
                        Scan QR code to quickly add bank details
                      </small>
                    </>
                  ) : (
                    <div
                      style={{
                        height: "100%",
                        justifyContent: "center",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      QR code not Available
                    </div>
                  )}
                </Col>
              </Row>
            ) : (
              <p
                className="text-muted text-center"
                style={{
                  height: "70vh",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                No bank details available.
              </p>
            )}
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
}
